import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { DEPRECATED_backwardsCompatibleValues } from "@faire/web--source/common/localization/localize";
import { Column } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { observer } from "mobx-react";
import * as React from "react";
import styled from "styled-components";
import { AppDownload } from "@faire/retailer-visitor-shared/components/MobileAppPromoBanner/AppDownload";
import { getTotalBrandCount } from "@faire/retailer-visitor-shared/lib/getMarketingCount";
var AppDownloadCTABase = function() {
    var isMobile = useViewport().isMobile;
    var message = function() {
        return isMobile ? /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "Nseqef",
            defaultMessage: [
                {
                    type: 0,
                    value: "Over "
                },
                {
                    type: 1,
                    value: "numBrands"
                },
                {
                    type: 0,
                    value: " brands at your fingertips"
                }
            ],
            values: DEPRECATED_backwardsCompatibleValues({
                numBrands: getTotalBrandCount()
            })
        }) : /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "sitfJ+",
            defaultMessage: [
                {
                    type: 0,
                    value: "Shop on-the-go with the Faire app"
                }
            ]
        });
    }();
    return /*#__PURE__*/ _jsxs(Container, {
        children: [
            isMobile ? /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraphSansMedium",
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "AD1zFP",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Get the Faire wholesale app"
                        }
                    ]
                })
            }) : null,
            /*#__PURE__*/ _jsx(Typography, {
                variant: {
                    mobileAndAbove: "paragraphSansRegular",
                    tabletAndAbove: "pageHeaderSerifRegular"
                },
                children: message
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                size: "2x"
            }),
            /*#__PURE__*/ _jsx(AppDownload, {
                eventPrefix: "/footer-mweb",
                noModal: isMobile
            })
        ]
    });
};
export var AppDownloadCTA = observer(AppDownloadCTABase);
var Container = styled(Column).attrs({
    align: {
        mobileAndAbove: "normal",
        desktopAndAbove: "flex-start"
    }
}).withConfig({
    componentId: "sc-5cabb977-0"
})([
    "",
    "{background-color:",
    ";border-top:1px solid ",
    ";padding:",
    ";width:100vw;}",
    "{padding:",
    ";}",
    "{max-width:429px;padding:",
    ";}",
    "{max-width:600px;}"
], responsiveMediaQueries.mobile, Core.surface.muted, Core.border.muted, getSpacing("3x"), responsiveMediaQueries.tablet, getSpacing("4x", 96, "8x"), responsiveMediaQueries.desktopAndAbove, getSpacing("3x", 96, "5x", 0), responsiveMediaQueries.xLargeAndAbove);
